import React from "react";

import { Accordion, AccordionItem, AccordionContent } from "@/components/ui/accordion";
import CustomStructuredText from "@/components/CustomStructuredText/CustomStructuredText";
import Typography from "@/components/Typography/Typography";

import { ICustomAccordionProps } from "@/interfaces/CustomAccordion/CustomAccordion";

export default function CustomAccordion({ contents, expanded }: ICustomAccordionProps) {
  return (
    <>
      <Accordion
        type="single"
        collapsible
        orientation="horizontal"
        value={expanded ? "item-1" : ""}
      >
        <AccordionItem className="border-none border-b-0" value="item-1">
          <AccordionContent>
            <div className="mt-6">
              <CustomStructuredText
                data={contents}
                listWrapper={(list, key) => (
                  <div key={key} className="cmd:columns-2 cmd:gap-8 mt-6 pl-6">
                    {list}
                  </div>
                )}
                listItemWrapper={(listItem, key) => (
                  <Typography key={key} variant="breadcrumbs-normal" className="!text-base">
                    {listItem}
                  </Typography>
                )}
              />
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  );
}
